import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { GET_URL } from '@utils/api/endpoints';
import { BaseError } from '@utils/types/shared/base';
import {
  PriorityQueueItem,
  PriorityQueueItemResponse
} from '@utils/types/back-office/priority-queue';

export const useGetPriorityQueueItem = (itemId: string | null) => {
  return useQuery<PriorityQueueItem, AxiosError<BaseError>>(
    ['priorityQueueItem', itemId],
    async () => {
      const { priorityQueueItem } = GET_URL(itemId!);
      const { data } =
        await Axios.get<PriorityQueueItemResponse>(priorityQueueItem);
      return data.result;
    },
    {
      enabled: !!itemId,
      staleTime: 10_000,
      refetchInterval: 10_000,
      useErrorBoundary: false,
      keepPreviousData: true
    }
  );
};
